export const splitNewLines = (text: string) => {
  if (!text) return text;
  const splited = text.split("\n").filter((str: string) => str);

  return splited.map((str: string) => <p key={Math.random()}>{str}</p>);
};
